import React from "react";
import Fab from "@material-ui/core/Fab";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";

const propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default function QuickGuideFloatingButton({
  style,
  icon,
  tooltipTitle,
  buttonText,
  component,
  size
}) {
  const [run, setRun] = React.useState(false);

  const QuickGuideComponent = component;

  return (
    <React.Fragment>
      <Tooltip className="position-fixed z-index-1" title={tooltipTitle}>
        <Fab
          variant="extended"
          size={size}
          color="primary"
          style={style}
          onClick={() => setRun(true)}
        >
          <span>{buttonText}</span>
          <span>{icon}</span>
        </Fab>
      </Tooltip>
      <QuickGuideComponent start={run} onChange={(val) => setRun(val)} />
    </React.Fragment>
  );
}

QuickGuideFloatingButton.defaultProps = {
  style: {
    bottom: "3%",
    left: "3%",
    backgroundColor: "#0052CC",
    textTransform: "none",
  },
  size:"small",
  buttonText: "",
  icon: <HelpIcon fontSize="small" />,
  tooltipTitle: "Quick Guide",
};


QuickGuideFloatingButton.propTypes = propTypes;